import React from "react";
import { useQuery } from "react-query";
import { fetchDataList, sendEmail } from "../api";
import { GlobalContext } from "../context/GlobalContext";
import { useNotifications } from "../helpers/useNotifications";
import SEO from "../components/SEO/SEO";

function Contact() {
  const { isMobile } = React.useContext(GlobalContext);
  const createNotification = useNotifications();

  const { data: emailSource } = useQuery(["general-email"], () =>
    fetchDataList("general")
  );

  //* handle form submit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = emailSource.email;
    const subject = e.target[2]?.value;
    const message = `From: ${e.target[0]?.value}\n E-Mail: ${e.target[1]?.value}\n\n ${e.target[3]?.value}`;

    try {
      const result = await sendEmail(email, subject, message);
      createNotification("success", result.message);
    } catch (error) {
      createNotification("error", error.message);
    }

    const formular = document.getElementById("contactForm");
    formular.reset();
  };

  return (
    <>
      <SEO
        title="Kontakt"
        keywords="Kontakt"
        description="Kontakt aufnehmen"
        type="Kontakt"
        url={window.location.href}
      />
      <div
        className={`${!isMobile && "article-text"} ${
          isMobile && "add-padding-20"
        } text-justify text-light`}
      >
        <h1 className="text-light article-header">Kontakt aufnehmen</h1>
        <br />
        <form onSubmit={handleSubmit} id="contactForm">
          <div className="form-group">
            <label className="text-light" for="formName">
              Name
            </label>
            <input type="text" className="form-control" id="formName" />
          </div>

          <div className="form-group">
            <label className="text-light" for="formMail">
              E-Mail
            </label>
            <input
              type="email"
              className="form-control"
              id="formMail"
              required
            />
          </div>

          <div className="form-group">
            <label className="text-light" for="formTopic">
              Betreff
            </label>
            <input
              type="text"
              className="form-control"
              id="formTopic"
              required
            />
          </div>

          <div className="form-group">
            <label className="text-light" for="formMessage">
              Nachricht
            </label>
            <textarea
              className="form-control"
              id="formMessage"
              rows="5"
              required
            ></textarea>
          </div>
          <div className="text-right">
            <button type="submit" className="btn btn-primary formsubmit">
              Absenden
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default Contact;
